var exports = {
  "Pf": "x112a1f60--a3d989--label",
  "wm": "x112a1f60--a3d989--logo",
  "_8": "x112a1f60--a3d989--img",
};

module.exports = exports;
